import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteDifficulty, getDifficulties } from '../../store/actions/difficulties/difficulties.action';
import DifficultiesList from '../../components/Difficulties/Difficulties';

import '../../styles/piece.css';

const DifficultiesContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const isCreating = useSelector((state) => state.difficulties.isCreating);
  const difficulties = useSelector((state) => state.difficulties.list);
  const isFetching = useSelector((state) => state.difficulties.isFetching);
  const difficultyToBeEdit = useSelector((state) => state.difficulties.difficultyToBeEdit);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const difficultyCategory = categories.find((category) => category.link === 'difficulties');
      if (difficultyCategory) {
        setMode(difficultyCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('Difficulty category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Handle delete difficulty
  const handleDeleteDifficulty = useCallback((difficulty) => {
    dispatch(deleteDifficulty(difficulty));
  }, [dispatch]);

  // Initialize on mount
  useEffect(() => {
    dispatch(getDifficulties());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state with custom loader
  if (isFetching) {
    return (
      <div className="loader">
        <svg viewBox="0 0 32 32" width="32" height="32">
          <circle id="spinner" cx="16" cy="16" r="14" fill="none" />
        </svg>
      </div>
    );
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  // Prepare difficulty info object
  const difficultyInfo = {
    deleteDifficulty: handleDeleteDifficulty,
    difficulties
  };

  return (
    <section>
      <DifficultiesList mode={mode} difficultyInfo={difficultyInfo} />
    </section>
  );
};

export default DifficultiesContainer;
